import { render } from "./FaqPage.vue?vue&type=template&id=7940dfea&scoped=true"
import script from "./FaqPage.vue?vue&type=script&lang=js"
export * from "./FaqPage.vue?vue&type=script&lang=js"

import "./FaqPage.vue?vue&type=style&index=0&id=7940dfea&scoped=true&lang=css"

import exportComponent from "/tmp/build_37390889/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7940dfea"]])

export default __exports__